export default __webpack_public_path__ + "static/media/handshake.8b2bb9d4.jpg";